const form = {
    Detail: [
        {
            label: 'Shipment',
            type: 'Tittle',
            name: 'Shipment',
        },
        {
            label: 'Supplier',
            type: 'Header',
            name: 'supplier',
        },
        {
            label: 'Name',
            type: 'Text',
            name: 'Name',
            id: 'SupplierName'
        },
        {
            label: 'Address',
            type: 'Text',
            name: 'Address',
            id: 'SupplierAdress'
        },
        {
            label: 'Consignee',
            type: 'Header',
            name: 'Consignee',
        },
        {
            label: 'Name',
            type: 'Text',
            name: 'Name',
            id: 'ConsigneeName'
        },
        {
            label: 'Address',
            type: 'Text',
            name: 'Address',
            id: 'ConsigneeAdress'
        },
        {
            label: 'Delivery',
            type: 'Header',
            name: 'Delivery',
        },
        {
            label: 'Name',
            type: 'Text',
            name: 'Name',
            id: 'Delivery'
        },
        {
            label: 'Address',
            type: 'Text',
            name: 'Address',
            id: 'DeliveryAdress'
        },
        {
            type: 'div',
            name: 'hr'
        },
        {
            label: 'Route',
            type: 'Header',
            name: 'Route',
        },
        {
            label: 'Origin',
            type: 'Text',
            name: 'Origin Port',
            id: 'POL'
        },
        {
            label: 'Destination',
            type: 'Text',
            name: 'Destination Port',
            id: 'POD'
        },
        {
            label: 'ETD',
            type: 'info',
            name: 'ETD',
            id: 'ETD',
            table: true,
            columns: [
                { label: "", key: "Serial", width: 20, },
                { label: "ETD", key: "EventDate", width: 90, },
                { label: "Update date", key: "UpdateDate", width: 90, },
            ],
            // data: [],
            EventId: 2
        },
        {
            label: 'ATD',
            type: 'Text',
            name: 'ATD',
            id: 'ATD',
            labelTe: 'PickUp:',
            idTe: 'FRDPP',
        },
        // {
        //     label: 'New ETD',
        //     type: 'info',
        //     name: 'NewETD',
        //     id: 'NewETD',
        //     table: true,
        //     columns: [
        //         { label: "", key: "Serial", width: 20, },
        //         { label: "New ETD", key: "EventDate", width: 70, },
        //         { label: "Update date", key: "UpdateDate", width: 80, },
        //     ],
        //     // data: [],
        //     EventId: 2
        // },
        // {
        //     label: 'New ETA',
        //     type: 'info',
        //     name: 'NewETA',
        //     id: 'NewETA',
        //     table: true,
        //     columns: [
        //         { label: "", key: "Serial", width: 20, },
        //         { label: "New ETA", key: "EventDate", width: 70, },
        //         { label: "Update date", key: "UpdateDate", width: 80 },
        //     ],
        //     // data: [],
        //     EventId: 1
        // },
        {
            label: 'ETA',
            type: 'info',
            name: 'ETA',
            id: 'ETA',
            table: true,
            columns: [
                { label: "", key: "Serial", width: 20, },
                { label: "ETA", key: "EventDate", width: 90, },
                { label: "Update date", key: "UpdateDate", width: 90 },
            ],
            // data: [],
            EventId: 1
        },
        {
            label: 'ATA',
            type: 'Text',
            name: 'ATA',
            id: 'ATA',
            labelTe: 'ATA To Final Destination',
            idTe: 'ATA'
        },
        {
            type: 'div',
            name: 'hr'
        },
        {
            label: 'General',
            type: 'Header',
            name: 'General',
        },
        {
            label: 'Project',
            type: 'Text',
            id: 'Project'
        },
        {
            label: 'Incoterm',
            type: 'Text',
            id: 'Incoterm'
        },
        {
            label: 'HBL/HAWB',
            type: 'Text',
            id: 'HBL_HAWB'
        },
        {
            label: 'MBL/AWB',
            type: 'Text',
            id: 'MBL_AWB'
        },
        // {
        //     label: '3PL:',
        //     type: 'Text',
        //     name: 'ATA',
        //     id: 'ATA'
        // },
        // {
        //     label: '3PL Reference:',
        //     type: 'Text',
        //     name: 'ATA',
        //     id: 'ATA'
        // },
        {
            label: 'Carrier',
            type: 'Text',
            id: 'Carrier'
        },
        // {
        //     label: 'Customs Broker:',
        //     type: 'Text',
        //     name: 'ATA',
        //     id: 'ATA'
        // },
        {
            label: 'Agent',
            type: 'Text',
            id: 'Agent'
        },
        {
            label: 'Co-Loader',
            type: 'Text',
            id: 'CoLoader'
        },
        {
            label: 'Vessel',
            type: 'Text',
            id: 'Vessel_'
        },
        {
            label: 'Voyage/Flight No',
            type: 'Text',
            id: 'Voyage_FlightNumber'
        },
        {
            label: '3PL Reference',
            type: 'Text',
            id: 'InternalRef'
        },
        {
            label: 'Customer Reference',
            type: 'Text',
            name: 'ATA',
            id: 'ClientRef'
        },
        {
            type: 'div',
            name: 'hr'
        },
        {
            label: 'Cargo',
            type: 'Header',
            name: 'Cargo',
        },
        {
            label: 'Weight',
            type: 'Text',
            id: 'Weight'
        },
        {
            label: 'Volume',
            type: 'Text',
            id: 'Volume'
        },
        {
            label: 'Pieces',
            type: 'Text',
            id: 'Pieces'
        },
        {
            label: 'Dimensions',
            type: 'Text',
            id: 'Dimension'
        },
        {
            label: 'DGR',
            type: 'Text',
            id: 'DGR'
        },
        {
            label: 'IMO',
            type: 'Text',
            id: 'IMO'
        },
        {
            label: 'Cargo',
            type: 'Text',
            id: ''
        },
    ],
    Container: [
        {
            label: 'Container',
            type: 'Tittle',
            name: 'container',
        },
        {
            label: 'Container Information',
            type: 'Header',
            name: 'container',
        },
        {
            label: 'Shipment No.',
            type: 'Text',
            name: 'Name',
            id: 'ShipmentNumber',
            link: true
        },
        {
            label: 'Container No.',
            type: 'Text',
            name: 'Name',
            id: 'NoContainer'
        },
        {
            label: 'Container Type',
            type: 'Text',
            name: 'Container',
            id: 'ContainerType'
        },
        {
            label: 'Temperature',
            type: 'Text',
            name: 'Temperature',
            id: 'Temperature'
        },
        {
            label: 'Ventilation',
            type: 'Text',
            name: 'Ventilation',
            id: 'Ventilation'
        },
        {
            label: 'Volume',
            type: 'Text',
            id: 'Volume'
        },
        {
            type: 'div',
            name: 'hr'
        },
        {
            label: 'General',
            type: 'Header',
            name: 'General',
        },
        {
            label: 'DGR',
            type: 'Text',
            id: 'DGR'
        },
        {
            label: 'IMO',
            type: 'Text',
            id: 'IMO'
        },
        {
            label: 'ETD',
            type: 'Text',
            name: 'ETD',
            id: 'ETD'
        },
        {
            label: 'ETA',
            type: 'Text',
            name: 'ETA',
            id: 'ETA'
        },
        {
            label: 'Consignee',
            type: 'Text',
            id: 'ConsigneeName'
        },
        {
            type: 'div',
            name: 'hr'
        },
        {
            label: 'Cargo',
            type: 'Header',
            name: 'Cargo',
        },
        {
            label: 'Cargo Description',
            type: 'Text',
            id: 'DescriptionLoad'
        },
        {
            label: 'Dimension',
            type: 'Text',
            id: 'Dimension'
        },
        {
            label: 'Total Pieces',
            type: 'Text',
            id: 'Pieces'
        },
        {
            label: 'Total Weight',
            type: 'Text',
            id: 'Weight'
        },
        {
            label: 'Total Volume',
            type: 'Text',
            id: 'Volume'
        },
    ]
}

export default form;